exports = module.exports = require("../../../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._23BXst9dds18M47PepFLzF .btn{height:2.42857rem;padding-right:2.14286rem;padding-left:2.14286rem}\n", ""]);

// exports
exports.locals = {
	"confirmOriginalAddress": "_23BXst9dds18M47PepFLzF"
};